import React from 'react';
import Label from '../common/Label';
import Dropdown from '../common/Dropdown';

const UsersTable = ({
  currentUsers,
  selectedUsers,
  selectAll,
  handleUserSelect,
  handleSelectAllChange,
  handleSort,
  sortConfig,
  highlightText,
  search,
  allOrganizations,
  allFacilities,
  onRoleChange,
}) => {
  const organizationMap = {};
  if (allOrganizations && allOrganizations.length > 0) {
    allOrganizations.forEach((org) => {
      organizationMap[org.id] = org.name;
    });
  }

  const facilityMap = {};
  if (allFacilities && allFacilities.length > 0) {
    allFacilities.forEach((facility) => {
      facilityMap[facility.id] = facility.name;
    });
  }

  return (
    <>
      {/* Checkbox and Label for All Members */}
      <div className="flex items-center mb-4 space-x-4 pl-4">
        <input
          type="checkbox"
          className="form-checkbox h-5 w-5"
          checked={selectAll}
          onChange={handleSelectAllChange}
        />
        <Label htmlFor="allMembers" variant="gray">
          All members
        </Label>
      </div>
      <div className="overflow-auto min-h-64 md:min-h-0 order-1 xl:order-none">
        <table className="table-auto w-full bg-white shadow-lg rounded-lg">
          <thead>
            <tr className="text-custom-dark-blue text-left">
              <th className="px-4 py-2 cursor-pointer whitespace-nowrap truncate" />
              {/**  
                Temporarily removing the 'name' column as it is no longer provided by the backend.
                Need to confirm this change with the backend and product teams.
                The 'name' column is commented out to enable the app to be deployed to production.
              */}
              {/**
                 <th
                    className="px-4 py-2 cursor-pointer whitespace-nowrap truncate"
                    onClick={() => handleSort('name')}
                  >
                   Name{' '}
                  {sortConfig.key === 'name' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
                  </th>
               */}
              <th
                className="px-4 py-2 cursor-pointer whitespace-nowrap truncate"
                onClick={() => handleSort('email')}
              >
                Email{' '}
                {sortConfig.key === 'email' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
              </th>
              <th
                className="px-4 py-2 cursor-pointer whitespace-nowrap truncate"
                onClick={() => handleSort('organization')}
              >
                Organization{' '}
                {sortConfig.key === 'organization' &&
                  (sortConfig.direction === 'ascending' ? '↑' : '↓')}
              </th>
              <th
                className="px-4 py-2 cursor-pointer whitespace-nowrap truncate"
                onClick={() => handleSort('facility')}
              >
                Facility{' '}
                {sortConfig.key === 'facility' &&
                  (sortConfig.direction === 'ascending' ? '↑' : '↓')}
              </th>
              <th
                className="px-4 py-2 cursor-pointer whitespace-nowrap truncate"
                onClick={() => handleSort('role')}
              >
                Role{' '}
                {sortConfig.key === 'role' && (sortConfig.direction === 'ascending' ? '↑' : '↓')}
              </th>
              {/* <th
                className="px-4 py-2 cursor-pointer whitespace-nowrap truncate"
                onClick={() => handleSort('last_active')}
              >
                Last Active{' '}
                {sortConfig.key === 'last_active' &&
                  (sortConfig.direction === 'ascending' ? '↑' : '↓')}
              </th> */}
            </tr>
          </thead>
          <tbody>
            {currentUsers.map((user, index) => {
              return (
                <tr key={index} className="text-left text-gray-700">
                  <td className="px-4 py-2 whitespace-nowrap truncate">
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5"
                      checked={selectedUsers[user.email] || false}
                      onChange={(e) => handleUserSelect(e, user.email)}
                    />
                  </td>
                  {/**  
                Temporarily removing the 'name' column as it is no longer provided by the backend.
                Need to confirm this change with the backend and product teams.
                The 'name' column is commented out to enable the app to be deployed to production.
              */}
                  {/**
                 <td className="px-4 py-2 whitespace-nowrap truncate">
                  {highlightText(user.name, search)}
                </td>
                 */}
                  <td className="px-4 py-2 whitespace-nowrap truncate">
                    {highlightText(user.email, search)}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap truncate">
                    {organizationMap[user.organization] || 'N/A'}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap truncate">
                    {facilityMap[user.facility] || 'N/A'}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap">
                    <Dropdown
                      options={['admin', 'user']}
                      selectedOption={user.role}
                      onSelect={(newRole) => onRoleChange(user, newRole)}
                    />
                  </td>
                  {/* <td className="px-4 py-2 whitespace-nowrap truncate">{user.last_active}</td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default UsersTable;
